import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/views/home')
const News = () => import('@/views/news')
const Detail = () => import('@/views/detail')
const Protocol = () => import('@/views/protocol')
const Register = () => import('@/views/register')
// 移动端
const MHome = () => import('@/views/mobile/m-home')
const MDetail = () => import('@/views/mobile/m-detail')
const MNews = () => import('@/views/mobile/m-news')
const MRegister = () => import('@/views/mobile/m-register')
const MProtocol = () => import('@/views/mobile/m-protocol')



import { isPc } from "@/util/index"

Vue.use(Router)

// PC端
const PCrouter = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    component: isPc() ? Home : MHome,
    name: 'home',
    meta: {
      keep: true
    }
  },
  {
    path: '/dmg',
    component: isPc() ? Home : MHome,
    name: 'dmg',
    meta: {
      keep: true
    }
  },
  {
    path: '/news',
    component: isPc() ? News : MNews,
    name: 'news',
  },
  {
    path: '/detail',
    component: isPc() ? Detail : MDetail,
    name: 'detail',
  },
  {
    path: '/protocol',
    component: isPc() ? Protocol : MProtocol,
    name: 'protocol',
  },
  {
    path: '/register',
    component: isPc() ? Register : MRegister,
    name: 'register',
  },
  {
    path: '*',
    redirect: '/home',
  },
]

const toprouter = new Router({
  mode: 'history',
  routes: PCrouter,
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition
    } else {
      if (to.hash) {
        return {
          selector: to.hash,
        }
      }
    }
  }
})

export default toprouter

